/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import uuid from 'uuid'
import { isMobile } from 'react-device-detect'
import {
  BettingHistoryHeader,
} from '@views/BettingHistory/BettingHistoryListItem/index.style'
import { DiaIco, GmoneyIco } from '@shared/Icon/MoneyIcon'
import SuccessImg from '@assets/images/icon/betting_history_icon/success.png'
import FailImg from '@assets/images/icon/betting_history_icon/fail.png'
import CancelImg from '@assets/images/icon/betting_history_icon/cancel.png'
import CancelBettorImg from '@assets/images/icon/betting_history_icon/cancel-bettor.png'

import BettingHistoryListItemSpecial from '@views/BettingHistory/BettingHistoryListItem/BettingHistoryListItemSpecial'
import { BettingHistoryListItemTournament }
  from '@views/BettingHistory/BettingHistoryListItem/BettingHistoryListItemTournament'
import { BettingFoldGroupedMap, BettingInfo, BettingRecordTrack } from '@store/bettingHistoryStore'
import { BET_CANCEL_TYPE, BET_HIT_STATE, EXTRA_ODDS_TYPE, PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import { formatNumber, getRatioTicketMoney } from '@utils/utils'
import { Schema$BettorBetInfo } from '@protocol/my'
import useRootStore from '@store/useRootStore'
import PageLoading from '@components/PageLoading'
import { Popover } from 'antd'
import AdditionalDividendMarkImg from '@assets/images/icon/matchup_icon/dividend-card/additional-dividend-mark.png'
import * as _ from 'lodash'
import { SharedBettingListWrap } from './index.style'
import { getSportIconElementsAscendingOrderBySportIdAndRemoveDuplicated } from '@utils/jsxutils'

interface SharedBettingListPopupProp {
  bettingRecordTrack?: BettingRecordTrack
  bettorBetId?: string
}

const SharedBettingListPopup: React.FC<SharedBettingListPopupProp> = (props: SharedBettingListPopupProp) => {
  const { bettingHistoryStore, componentStore, matchupStore } = useRootStore()
  const { bettingRecordTrack, bettorBetId } = props
  const emptyBet: BettingInfo = {
    betMoney: 0,
    betMoneyType: undefined,
    betNumber: '',
    betTicket: false,
    bet_property: 0,
    callType: undefined,
    cancelType: 0,
    canceled: false,
    category: undefined,
    closed: false,
    clubId: '',
    clubName: '',
    createdAt: '',
    date_closed: '',
    dividend: 0,
    dividendRate: '',
    foldCount: 0,
    hitRatio: 0,
    hitState: 0,
    id: '',
    pickId: '',
    typeOn: undefined,
    userId: '',
    deleted: false,
    bettorBetId: '',
  }
  const emptyFolds: BettingFoldGroupedMap = {}
  let initBettingRecordTrack: BettingRecordTrack = {
    betId: null,
    firstDateOfMatch: null,
    close1: 0,
    close2: 0,
    bet: emptyBet,
    isSpecial: false,
    folds: emptyFolds,
    userPickWritten: false,
    userPickWrittenAll: false,
  }
  if (bettingRecordTrack) {
    initBettingRecordTrack = bettingRecordTrack
  }
  const [bettingRecordTrackModel, setBettingRecordTrackModel] = useState<BettingRecordTrack>(initBettingRecordTrack)
  const [isLoading, setLoading] = useState(false)
  const { close1 = 0, close2 = 0, bet = {} } = bettingRecordTrackModel
  const {
    foldCount,
    dividend,
    dividendRate,
    betMoneyType,
    hitState,
    extraOddsType,
    extraOddsItemPropertyId,
  } = bet as Schema$BettorBetInfo

  useEffect(() => {
    if (bettorBetId) {
      setLoading(true)
      fetch()
    }
  }, [bettorBetId])

  const fetch = async () => {
    const result = await bettingHistoryStore.getBettingRecordTrack(bettorBetId)
    setBettingRecordTrackModel(result)
    setLoading(false)
  }

  const finalDividend = betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G ? getRatioTicketMoney(dividend) : dividend

  // 상단 적중 여부 이미지
  let eleHitState
  switch (hitState) {
    case BET_HIT_STATE.SUCCESS:
      eleHitState = <img src={SuccessImg} alt="적중" className="hit-state-img"/>
      break
    case BET_HIT_STATE.FAIL:
      eleHitState = <img src={FailImg} alt="미적중" className="hit-state-img"/>
      break
    case BET_HIT_STATE.CANCEL:
      eleHitState = <img src={CancelImg} alt="적중 특례" className="hit-state-img"/>
      break
    case BET_HIT_STATE.ONGOING:
      eleHitState = <Fragment/>
      break
  }

  // 베팅 내역 각 경기별 적중 여부 이미지
  // const makeHitStateElement = () => {
  //   let element
  //   switch (hitState) {
  //     case BET_HIT_STATE.SUCCESS:
  //       element = <span className="success state">{HitStateToText(hitState)}</span>
  //       break
  //     case BET_HIT_STATE.FAIL:
  //       element = <span className="fail state">{HitStateToText(hitState)}</span>
  //       break
  //     case BET_HIT_STATE.CANCEL:
  //       element = <span className="cancel state">{HitStateToText(hitState)}</span>
  //       break
  //     case BET_HIT_STATE.ONGOING:
  //       element = <span className="ongoing state">{HitStateToText(hitState)}</span>
  //       break
  //   }
  //
  //   if (betCanceled) {
  //     element = <span className="cancel state">{HitStateToText(BET_HIT_STATE.CANCEL)}</span>
  //   }
  //
  //   return element
  // }

  const betFoldList = []
  if (bettingRecordTrackModel.isSpecial === true) {
    for (const key in bettingRecordTrackModel.folds) {
      const fold = bettingRecordTrackModel.folds[key]
      betFoldList.push(
        <BettingHistoryListItemSpecial
          key={uuid.v4()}
          fold={fold}
          close1={close1}
          close2={close2}
        />,
      )
    }
  } else {
    for (const key in bettingRecordTrackModel.folds) {
      const fold = bettingRecordTrackModel.folds[key]
      betFoldList.push(
        <BettingHistoryListItemTournament
          key={uuid.v4()}
          track={bettingRecordTrackModel}
          fold={fold}
          betCanceled={bettingRecordTrackModel.bet.canceled}
          betCancelType={bettingRecordTrackModel.bet.cancelType}
          bettorBetId={bettingRecordTrackModel.betId}
          clubId={bettingRecordTrackModel.bet.clubId}
          isShareHistory
        />,
      )
    }
  }

  let AdditionalDividendMark

  const extraOddsItemDetail = componentStore.getExtraOddsItemDetailByPropertyId(extraOddsItemPropertyId)
  if (!_.isEmpty(extraOddsItemDetail)) {
    const {
      name,
      rate,
    } = extraOddsItemDetail

    const popoverDividendTxt = <span className="popover-content-txt">신의가호 효과
      <span style={{ color: '#26aab8' }}>{`${name} +${rate} 배당`}</span></span>
    const popoverTrigger = isMobile ? 'click' : 'hover'
    AdditionalDividendMark = (
      <Popover
        placement="top"
        content={popoverDividendTxt}
        trigger={popoverTrigger}
        overlayClassName="white-popover only-txt"
        getPopupContainer={(triggerNode: any) => triggerNode.parentNode} /* body 하위에 div를 생성하지 않고 additional-dividend-mark과 동일 선상에 생성되도록 설정 - body 하위에 생성되면 아이폰에서 모달 뒤에 뜸 */
      >
          <span className="additional-dividend-mark">
            <img src={AdditionalDividendMarkImg} alt="신의가호 사용"/>
          </span>
      </Popover>
    )
  }
  const sportIconElements = _.map(getSportIconElementsAscendingOrderBySportIdAndRemoveDuplicated(
    _.map(bettingRecordTrackModel.folds, fold => fold.sportId), matchupStore.feedSupplier), element => (
    <span key={uuid.v4()}>
      {element}
    </span>
  ))

  return (
    <SharedBettingListWrap className={!isMobile && 'pc-shared-betting-list-wrap'}>
      <div className="shared-betting-info">
        {bettingRecordTrackModel.bet.cancelType !== BET_CANCEL_TYPE.NONE &&
          <img src={CancelBettorImg} alt="베팅취소" className="hit-state-img"/>
        }
        {eleHitState}
        <div className="shared-betting-info--item">
          <span className="shared-betting-info--item--txt">폴드</span>
          <span className="shared-betting-info--item--num">{foldCount}</span>
        </div>
        <span className="division-line"/>
        <div className="shared-betting-info--item">
          <span className="shared-betting-info--item--txt">배당{
            extraOddsType === EXTRA_ODDS_TYPE.GOD_BLESS_ITEM && AdditionalDividendMark}</span>
          <span className="shared-betting-info--item--num rate">{dividendRate}</span>
        </div>

      </div>

      <BettingHistoryHeader className="shared-list-header">
        {isLoading && (<PageLoading/>)}
        {!isLoading && (
          <Fragment>
            <div className="betting-history-header">
              <ul className="fold-money-list">
                <li className="fold-money-list--item fold">
                  <div className="sports-ico-wrap">
                    {sportIconElements}
                  </div>
                </li>
                <li className="fold-money-list--item final-dividend">
                  {betMoneyType === PROPERTY_ID.DIA && '예상적중다이아'}
                  {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) && '예상적중머니'}
                  <span className="final-dividend-value">
                    {formatNumber(finalDividend)}
                  </span>
                  {betMoneyType === PROPERTY_ID.DIA && <DiaIco/>}
                  {(betMoneyType === PROPERTY_ID.MONEY || betMoneyType === PROPERTY_ID.NEW_BET_TICKET_G) &&
                    <GmoneyIco/>}
                </li>
              </ul>
              <div className="division-line"/>
            </div>

            <div className="shared-list">
              {betFoldList}
            </div>
          </Fragment>
        )}

      </BettingHistoryHeader>
    </SharedBettingListWrap>
  )
}

export default observer(SharedBettingListPopup)
